var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EFF8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14275_9037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2178 16.5585V18.7654C22.2178 21.4362 20.0589 23.5951 17.3881 23.5951C14.7174 23.5951 12.5424 21.4362 12.5424 18.7654V18.0138C10.1755 17.6779 8.40039 15.6309 8.40039 13.2321V9.09002C8.40039 8.7062 8.70425 8.40234 9.08806 8.40234H11.1671C11.5509 8.40234 11.8548 8.7062 11.8548 9.09002C11.8548 9.47384 11.5509 9.77769 11.1671 9.77769H9.79173V13.2321C9.79173 15.1351 11.343 16.6864 13.2461 16.6864C15.1492 16.6864 16.7005 15.1351 16.7005 13.2321V9.77769H15.3251C14.9413 9.77769 14.6374 9.47384 14.6374 9.09002C14.6374 8.7062 14.9413 8.40234 15.3251 8.40234H17.4041C17.756 8.40234 18.0758 8.7062 18.0758 9.09002V13.2321C18.0758 15.6309 16.3006 17.662 13.9338 18.0138V18.7654C13.9338 20.6685 15.485 22.2198 17.3881 22.2198C19.2912 22.2198 20.8425 20.6685 20.8425 18.7654V16.5585C19.771 16.1747 19.1953 14.9912 19.5791 13.9197C19.9629 12.8482 21.1463 12.2725 22.2178 12.6563C23.2893 13.0401 23.8651 14.2236 23.4812 15.2951C23.2733 15.8868 22.7936 16.3506 22.2178 16.5585Z",
    fill: "#0C66E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14275_9037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeNotes);
export default __webpack_public_path__ + "static/media/officeNotes.9cc4b71eba77e41b9feb70237dcfac72.svg";
export { ForwardRef as ReactComponent };